import './App.css';
import { Dictionary } from './Components/Dictionary'

function App() {
    return (

        <>
            <div className="App">
                <header className="App-header"> </header>
                <main>
                    <Dictionary />
                </main>

            </div>
        </>
    );
}
export default App;